import { Component, OnInit } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { Globals } from '../_globals';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { StoreService } from 'app/_services/store.service';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { NotificationService } from 'app/_services/notification.service';



@Component({
    selector: 'app-push-notifications',
    templateUrl: './push-notifications.component.html',
    styleUrls: ['./push-notifications.component.css']
})
export class PushNotificationsComponent implements OnInit {

    pushNotificationsForm: FormGroup;

    cookieStore: any;
    storeId: any;

    role: any;
    routeRole: any;

    constructor(
        public _authService: AuthService,
        public globals: Globals,
        public fb: FormBuilder,
        public _storeService: StoreService,
        public cookieService: CookieService,
        public router: Router,
        public notificationService: NotificationService
    ) {
        const hasCurrentStore = cookieService.check('currentStore');
        if (hasCurrentStore) {
            this.cookieStore = JSON.parse(cookieService.get('currentStore'));
            this.storeId = this.cookieStore.id;
        } else {
            this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
        }

        this.role = globals.user.role;
        this.routeRole = globals.user.routeRole;

        this.pushNotificationsForm = fb.group({
            title: new FormControl('', [Validators.required]),
            body: new FormControl('', [Validators.required])
        });
    }

    ngOnInit() {}

    public onPushNotificationsFormSubmit() {
        const values = this.pushNotificationsForm.value;
        const body = {
            title: values.title,
            body: values.body,
            storeId: this.storeId
        };
        console.log(body);
        this._storeService.sendNotification(body)
            .subscribe((data: any) => {
                console.log(data);
                this.pushNotificationsForm.reset();
                this.notificationService.notify(
                    'success',
                    'Push Notification',
                    'Push Notification has successfully been sent',
                    'top',
                    'right');
            })
    }




}



// WEBPACK FOOTER //
// ./src/app/push-notifications/push-notifications.component.ts